<template>
  <v-footer color="transparent">
    <v-row no-gutters>
      <div>
        <v-btn
            v-for="link in links"
            :key="link.link"
            color="primary"
            text
            @click="$refs[`${link.ref}`].dialog = true"
            class="text-capitalize mr-1 font-weight-regular"
        >
          {{ $t('components:footer.' + link.text) }}
        </v-btn>
      </div>
      <!-- Social media icons - uncomment if needed -->
      <!-- <div>
        <v-btn
            v-for="icon in icons"
            :key="icon.icon"
            :href="icon.link"
            class="mr-1"
            color="greyTint"
            icon
        >
          <v-icon size="24px">{{ icon.icon }}</v-icon>
        </v-btn>
      </div> -->

      <ConditionsComponent ref="conditions" />

      <ImprintComponent ref="imprint" />

    </v-row>
  </v-footer>
</template>

<script>
import ConditionsComponent from "@/modules/core/components/Footer/ConditionsComponent";
import ImprintComponent from "@/modules/core/components/Footer/ImprintComponent";

export default {
  name: 'FooterComponent',
  components: {ImprintComponent, ConditionsComponent},
  data: () => ({
    links: [
      { text: 'imprint', ref: 'imprint' },
      { text: 'conditions', ref: 'conditions' }
    ]
  })
}
</script>

<style src="@/modules/core/components/Footer/Footer.scss" lang="scss"/>

